import React, { createContext, useState } from "react";

interface EditScheduleActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
}

export const EditScheduleActionContext = createContext<EditScheduleActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},  
});

interface EditScheduleActionProviderProps {
  children: React.ReactNode;
}

export const EditScheduleActionProvider: React.FC<EditScheduleActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);  

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,    
  };
  return (
    <EditScheduleActionContext.Provider value={value}>      
      {children}
    </EditScheduleActionContext.Provider>
  );
};
